export default class BracketGameFixtureScoreModel {
  public participantOne: string | null = null;
  public participantTwo: string | null = null;
}
